/**
 * A classifier with a live prompt owns its moderation boundaries: deployment
 * writes them from the live thresholds and re-points them at every go-live. The
 * moderation boundaries page therefore shows those rows but does not let them be
 * changed by hand, and says why wherever a control is disabled.
 */
export const PROMPT_MANAGED_MESSAGE =
    'Managed by the classifier prompt — change it by redeploying the classifier.'
